import { useEffect, useState, useCallback } from "react";
import dayjs from "@/lib/day";
import styles from "@/styles/Video.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var formatCountDown = function formatCountDown(diff) {
  if (diff > 0) {
    if (diff >= 86400) {
      return "".concat(Math.floor(diff / 86400), "\u65E5");
    }

    var format = "H時間";

    if (diff < 3600) {
      format = "m分";
    }

    if (diff < 300) {
      format = "m分s秒";
    }

    if (diff < 60) {
      format = "s秒";
    }

    return dayjs.unix(diff).utc().format(format);
  }

  return "00:00:00";
};

export default function LiveBefore(_ref) {
  var watch = _ref.watch,
      state = _ref.state;
  var calculateTimeLeft = useCallback(function () {
    var now = dayjs();
    var startDate = dayjs(new Date(watch.episode.encode_start_date));
    return startDate.diff(now, "seconds");
  }, []);

  var _useState = useState(calculateTimeLeft()),
      timeLeft = _useState[0],
      setTimeLeft = _useState[1];

  useEffect(function () {
    var timer = setTimeout(function () {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return function () {
      clearTimeout(timer);
    };
  });
  useEffect(function () {
    if (timeLeft <= 0) {
      state.reset();
    }
  }, [timeLeft]);
  return /*#__PURE__*/_jsx("div", {
    className: styles.livebefore,
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: "\u914D\u4FE1\u307E\u3067"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.timeleft,
        children: formatCountDown(timeLeft)
      })]
    })
  });
}